import React from 'react';

const authComponentContext = React.createContext();

export const AuthComponentProvider = authComponentContext.Provider;
export default authComponentContext;
